import { Stack, Typography } from "@mui/material";

type Props = {};

// Was a plain <h3> — bypassed the theme entirely (wrong font, wrong color,
// no dark-mode adaptation). This is reached by nearly every empty table/list
// in the app (see DataTable.tsx), so it's a high-visibility fix.
const NoItems = (props: Props) => {
  return (
    <Stack alignItems="center" gap={2} sx={{ paddingBlock: 4 }}>
      <img
        src="/images/empty.svg"
        width="128px"
        height="128px"
        alt="no items"
        style={{ transform: "scale(-1,1)" }}
      />
      <Typography variant="h6" color="text.secondary">
        لا يوجد عناصر
      </Typography>
    </Stack>
  );
};

export default NoItems;
